/* adapted from http://react-day-picker.js.org/examples/input-from-to */
import React from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import IconButton from "@material-ui/core/IconButton";
import ReplayIcon from "@material-ui/icons/Replay";
import TextField from "@material-ui/core/TextField";
import moment from "moment";
import DayPickerInput from "react-day-picker/DayPickerInput";
import "react-day-picker/lib/style.css";

import { formatDate, parseDate } from "react-day-picker/moment";

class DayPickerTextField extends React.Component {
  render() {
    return (
      <TextField
        {...this.props}
        value={this.props.value || ""}
        label={this.props.placeholder || ""}
        inputProps={{
          "aria-label": this.props.placeholder || "",
          placeholder: "",
        }}
      />
    );
  }
}

class DateFilter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      from: null,
      to: null,
    };
    this.handleFromChange = this.handleFromChange.bind(this);
    this.handleToChange = this.handleToChange.bind(this);
    this.handleRangeChange = this.handleRangeChange.bind(this);
    this.resetRange = this.resetRange.bind(this);
  }

  handleFromChange(from) {
    this.setState({ from });
    if (this.state.to) {
      this.handleRangeChange(from, this.state.to);
    }
  }

  handleToChange(to) {
    this.setState({ to });
    if (this.state.from) {
      this.handleRangeChange(this.state.from, to);
    }
  }

  handleRangeChange(from, to) {
    const floor = from && moment(from).startOf("day").toDate();
    const ceil = to && moment(to).endOf("day").toDate();
    this.props.onChange && this.props.onChange({ from: floor, to: ceil });
  }

  resetRange() {
    const range = { from: null, to: null };
    this.setState(range);
    this.props.onChange && this.props.onChange(range);
  }

  render() {
    const { from, to } = this.state;
    const modifiers = { start: from, end: to };
    const { classes } = this.props;
    return (
      <div className={classes.root} onClick={(e) => e.preventDefault()}>
        <DayPickerInput
          component={DayPickerTextField}
          ref={(el) => (this.from = el)}
          value={from}
          placeholder="From"
          format="MM/DD/YYYY"
          formatDate={formatDate}
          parseDate={parseDate}
          dayPickerProps={{
            selectedDays: [from, { from, to }],
            disabledDays: { after: to },
            toMonth: to,
            modifiers,
            numberOfMonths: 1,
            onDayClick: () => this.to.showDayPicker(),
          }}
          onDayChange={this.handleFromChange}
          onDayPickerShow={() => this.to.hideDayPicker()}
        />{" "}
        <DayPickerInput
          component={DayPickerTextField}
          ref={(el) => (this.to = el)}
          value={to}
          placeholder="To"
          format="MM/DD/YYYY"
          formatDate={formatDate}
          parseDate={parseDate}
          dayPickerProps={{
            selectedDays: [from, { from, to }],
            disabledDays: { before: from },
            modifiers,
            month: from,
            fromMonth: from,
            numberOfMonths: 1,
          }}
          onDayChange={this.handleToChange}
          onDayPickerShow={() => this.from.hideDayPicker()}
        />{" "}
        <IconButton color="primary" onClick={this.resetRange} style={{verticalAlign: 'bottom'}}>
          <ReplayIcon />
        </IconButton>
      </div>
    );
  }
}

DateFilter.propTypes = {
  classes: PropTypes.object.isRequired,
  onChange: PropTypes.func,
};

const styles = (theme) => ({
  root: {
    "& .DayPicker-Day": {
      borderRadius: 0,
    },
    "& .DayPicker-Day--start": {
      backgroundColor: `${theme.palette.primary.dark} !important`,
      borderTopLeftRadius: "50%",
      borderBottomLeftRadius: "50%",
    },
    "& .DayPicker-Day--end": {
      backgroundColor: `${theme.palette.primary.dark} !important`,
      borderTopRightRadius: "50%",
      borderBottomRightRadius: "50%",
    },
    "& .DayPicker-Day--selected:not(.DayPicker-Day--start):not(.DayPicker-Day--end):not(.DayPicker-Day--outside)":
      {
        backgroundColor: theme.palette.primary.light,
        color: theme.palette.primary.contrastText,
      },
  },
});

export default withStyles(styles)(DateFilter);



// WEBPACK FOOTER //
// ./src/components/Forms/DateRange.jsx